/**
 * The right-menu group ids, kept out of map.component.ts on purpose.
 *
 * They used to live on MapComponent, which made every importer — including
 * GoogleAnalyticsService, and through it the whole sales-forecast tool —
 * pull in MapComponent and its entire menu tree. That is also a genuine
 * import cycle (layers-menu -> menu-group -> map.component -> map-menu ->
 * layers-menu) that breaks module initialization in any bundle where the
 * map is not the entry point. Constants have no dependencies, so hosting
 * them here cuts the cycle at its only weak edge.
 */
export const MAPS_GROUP = 'MAPS_GROUP';
export const CHARTS_GROUP = 'CHARTS_GROUP';
export const PLACES_GROUP = 'PLACES_GROUP';
export const ALL_DATA_GROUP = 'ALL_DATA_GROUP';

export type MenuGroupType =
  | typeof MAPS_GROUP
  | typeof CHARTS_GROUP
  | typeof PLACES_GROUP
  | typeof ALL_DATA_GROUP;
